// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import './styles.scss';

import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import { useSelector } from 'react-redux';
import ReactPlayer from 'react-player';
import { Fade } from 'react-reveal';
import { APP_ID } from 'config/constants';
import Button from 'components/commonComponents/Button';
import SocialShare from 'components/modals/SocialShare';
import RedeemWallet from 'components/modals/RedeemWallet';
import Loader from 'components/commonComponents/Loader';
import EmptyState from 'components/commonComponents/EmptyState';
import { message } from 'antd';
import { WalletOutlined } from '@ant-design/icons';
import { cleanDescription } from 'utils/cleanHtml';


const ReferAndEarn = () => {
    const { currentLang, userDetails } = useSelector((store) => store.commonData);
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const [openShareSocial, setOpenShareSocial] = useState(false);
    const [openRedeem, setOpenRedeem] = useState(false);
    const [entries, setEntries] = useState([]);
    const [appInfo, setAppInfo] = useState(null);
    const [summary, setSummary] = useState('');
    const [messageApi, contextHolder] = message.useMessage();

    const fetchWallet = async () => {
        const res = await fetchData(restAPIs.getWallet(APP_ID, currentLang?.id));
        // The endpoint returns a list of wallet-credit entries (one per earn
        // event), not a single flat balance — the total is the sum of points
        // across every entry, same as the sibling EV apps on this backend.
        setEntries(res?.entities || []);
        setLoading(false);
    }

    const fetchAppinfo = async () => {
        const res = await fetchData(restAPIs.getAppInfo(APP_ID, currentLang?.id));
        if (res?.appInfo) {
            const tempRes=res?.appInfo
            setAppInfo(tempRes)
            var temp_appInfo = tempRes;
            var appStoreLink = temp_appInfo.appStoreLink ? temp_appInfo.appStoreLink : '';
            var googleStoreLink = temp_appInfo.googleStoreLink
              ? temp_appInfo.googleStoreLink
              : '';
            var websitelink = temp_appInfo.websitelink ? temp_appInfo.websitelink : '';
            var name = temp_appInfo.name ? temp_appInfo.name : '';
            var tagline = temp_appInfo.tagline ? temp_appInfo.tagline : '';
            var refCode = userDetails?.refCode;
            // Matches the shared "Electronic Village" cross-app share format
            // (same layout used by the Waqt/Alwaraq apps' share messages):
            // bold name, italic tagline, description, App Store / Play Store
            // / Website lines, then a web subscribe link with the ref code.
            var link =
              'Discounted Subscription :' +
              '\n' +
              websitelink.replace(/\/$/, '') +
              '/subscribe?refcode=' +
              refCode;
            var subbody = temp_appInfo.description;
            subbody = subbody.replace(/<style([\s\S]*?)<\/style>/gi, '');
            subbody = subbody.replace(/<script([\s\S]*?)<\/script>/gi, '');
            subbody = subbody.replace(/<\/div>/gi, '\n');
            subbody = subbody.replace(/<\/li>/gi, '\n');
            subbody = subbody.replace(/<li>/gi, '  *  ');
            subbody = subbody.replace(/<\/ul>/gi, '\n');
            subbody = subbody.replace(/<\/p>/gi, '\n');
            subbody = subbody.replace(/<br\s*\/?>/gi, '\n');
            subbody = subbody.replace(/<[^>]+>/gi, '');
            subbody = subbody.replace(/&nbsp;/gi, '');
            subbody =
              '*' + name + '*' +
              '\n' +
              '_' + tagline + '_' +
              '\n\n' +
              subbody +
              '\n' +
              'App Store : ' +
              appStoreLink +
              '\n' +
              'Play Store : ' +
              googleStoreLink +
              '\n' +
              'Website : ' +
              websitelink +
              '\n\n' +
              link;
              setSummary(subbody)

        }
        setLoading(false);
    }

    useEffect(() => {
        setLoading(true)
        fetchWallet();
        fetchAppinfo();
        window.scrollTo(0, 0);
    }, [currentLang]);

    const handleCloseShareSocial = () => {
        setOpenShareSocial(false);
    };

    const handleOpenShareSocial = () => {
        setOpenShareSocial(true);
    };

    const handleRedeemed = (msg) => {
        messageApi.open({
            type: 'success',
            content: msg,
        });
    };

    const totalPoints = entries.reduce((sum, item) => sum + (Number(item.wallet ?? item.credit ?? 0) || 0), 0);
    const infoEntry = entries.find((item) => item.description);
    const videoEntry = entries.find((item) => item.videoURL);
    const historyEntries = entries.filter((item) => Number(item.wallet ?? item.credit ?? 0) > 0);

    return (
        <div className='container __innerTopPad'>
            {contextHolder}
            <h4 style={{ color: '#a19c74', marginBottom: '10px' }}>{t('refer_earn')}</h4>
            <h1 className='__common-head'>{t('my_wallet')}</h1>

            {isLoading ?
                <Loader /> :
                <>
                    <div className='__wallet_layout'>
                        <Fade bottom cascade>
                            <div className='__wallet_card __wallet_points'>
                                <WalletOutlined className='__wallet_icon' />
                                <span className='__wallet_label'>{t('your_ev_points')}</span>
                                <span className='__wallet_value'>{totalPoints}</span>
                                <span className='__wallet_unit'>{t('points_unit')}</span>
                                <div className='__wallet_actions'>
                                    <Button
                                        handleOnClick={handleOpenShareSocial}
                                        label={t('share_now')} />
                                    <Button
                                        handleOnClick={() => setOpenRedeem(true)}
                                        style={{ background: 'transparent', border: '1px solid #e3a83a', color: '#e3a83a' }}
                                        label={t('redeem')} />
                                </div>
                            </div>
                        </Fade>

                        <Fade bottom cascade>
                            <div className='__wallet_card __wallet_info'>
                                <h6>{t('how_it_works')}</h6>
                                {infoEntry?.description ?
                                    <p dangerouslySetInnerHTML={{ __html: cleanDescription(infoEntry.description) }} /> :
                                    <p className='__wallet_muted'>{t('terms_not_published')}</p>
                                }
                                {videoEntry?.videoURL &&
                                    <div className='player-wrapper'>
                                        <ReactPlayer url={videoEntry.videoURL} controls={true}
                                            className='react-player'
                                            width='100%'
                                            height='100%'
                                        />
                                    </div>
                                }
                            </div>
                        </Fade>
                    </div>

                    {historyEntries.length > 0 &&
                        <div className='__wallet_card __wallet_history'>
                            <h6>{t('wallet_history')}</h6>
                            {historyEntries.map((item, idx) => (
                                <div className='__wallet_history_row' key={idx}>
                                    <span className='__wallet_history_badge'>+</span>
                                    <span className='__wallet_history_title'>{item.title || item.name}</span>
                                    <span className='__wallet_history_points'>+{item.wallet ?? item.credit}</span>
                                </div>
                            ))}
                        </div>
                    }

                    {entries.length === 0 && <EmptyState message={t('sorry_no_res')} />}
                </>
            }

            <SocialShare
                open={openShareSocial}
                onClose={handleCloseShareSocial}
                title={appInfo?.name}
                description={appInfo?.description}
                image={appInfo?.logo}
                url={window.location.href}
                summary={summary}
            />
            <RedeemWallet
                open={openRedeem}
                onClose={() => setOpenRedeem(false)}
                language={currentLang?.id}
                onRedeemed={handleRedeemed}
            />
        </div>
    );
};

export default ReferAndEarn;
